import React from 'react';
import { palette } from '../../styles/theme';

export function ConsultantsSVG ({ customStroke, className = '', selected = false, size }) {
    const stroke = customStroke || palette.icons;
    return (
        <svg className={`svg-icon svg-icon${selected && '-primary'} svg-icon-2x`} xmlns="http://www.w3.org/2000/svg" width= {size || 24} height={size || 24} viewBox="0 0 24 24" fill="none" style={{ marginBottom: '6px' }}>
            <g clipPath="url(#clip0_6255_14304)">
                <path d="M8 7C8 8.06087 8.42143 9.07828 9.17157 9.82843C9.92172 10.5786 10.9391 11 12 11C13.0609 11 14.0783 10.5786 14.8284 9.82843C15.5786 9.07828 16 8.06087 16 7C16 5.93913 15.5786 4.92172 14.8284 4.17157C14.0783 3.42143 13.0609 3 12 3C10.9391 3 9.92172 3.42143 9.17157 4.17157C8.42143 4.92172 8 5.93913 8 7Z" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M6 21V19C6 17.9391 6.42143 16.9217 7.17157 16.1716C7.92172 15.4214 8.93913 15 10 15H13.5" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M21 19L19 17L17 19" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M19 17V23" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
            <defs>
                <clipPath id="clip0_6255_14304">
                    <rect width="24" height="24" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
}
